export const styles = {
  text: {
    color: '#0F0F0F',
    fontFamily: {
      xs: 'Inter',
    },
    fontSize: {
      xs: '12px',
      md: '16px',
    },
    fontStyle: {
      xs: 'normal',
    },
    fontWeight: {
      xs: '400',
    },
    lineHeight: {
      xs: '125%',
      md: '140%',
    },
    letterSpacing: {
      xs: '0.2px',
    },
  },
  speechBubble: {
    display: 'flex',
    width: {
      xs: '220px',
      md: '315px',
    },
    padding: {
      xs: '6px',
      md: '16px',
    },
    borderRadius: {
      xs: '10px',
      md: '20px',
    },
    border: ' 0.51px solid rgba(255, 255, 255, 0.20)',
    background: 'rgba(232, 226, 255, 0.60)',
    backdropFilter: ' blur(10.317277908325195px)',
    position: 'absolute',
    zIndex: 1,
  },
};
